'use client'

import { useEffect } from 'react'

export default function CronInitializer() {
  useEffect(() => {
    const initializeCron = async () => {
      try {
        const response = await fetch('/api/cron/init', { 
          method: 'POST',
          headers: {
            'Cache-Control': 'no-cache'
          }
        });
        
        if (response.ok) {
          const result = await response.json();
          // Success - cron jobs initialized
        } else {
          console.warn('Failed to initialize cron jobs:', response.status);
        }
      } catch (error) {
        console.warn('Cron initialization failed:', error);
        // Don't throw error - just log it
      }
    };

    // Add delay to ensure app is fully loaded
    const timer = setTimeout(initializeCron, 5000);
    
    return () => clearTimeout(timer);
  }, []);

  return null // This component doesn't render anything
} 